module.exports = __webpack_public_path__ + "static/media/ball.d9e82885.png";